import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SliderField from 'launch/components/SliderField';
import { getComponentClasses } from '@99designs/common/utils/app';

class GallerySlider extends Component {
    constructor(props) {
        super();

        const { selectedItemIndex } = props;

        this.handleSliderFieldChange = this.handleSliderFieldChange.bind(this);

        this.state = {
            selectedIndex: selectedItemIndex,
        };
    }

    render() {
        const { items, variations } = this.props;
        const { selectedIndex } = this.state;
        const topLabels = items.map(item => item.topLabel);
        const bottomLabels = items.map(item => item.bottomLabel);
        const images = items.map(item => item.image);
        const classes = getComponentClasses('gallery-slider', variations);

        const imagesStyle = {
            width: `${items.length * 50}%`,
            marginLeft: `${25 - selectedIndex * 50}%`,
        };

        return (
            <div className={classes}>
                <div className="gallery-slider__images" style={imagesStyle}>
                    {images.map((image, index) => {
                        return (
                            <div
                                key={index}
                                className="gallery-slider__images__image"
                                data-selected={selectedIndex === index ? true : null}
                            >
                                {image}
                            </div>
                        );
                    })}
                </div>
                <div className="gallery-slider__labels">
                    {topLabels.map((label, index) => {
                        return (
                            <div
                                key={index}
                                className="gallery-slider__labels__label"
                                data-selected={selectedIndex === index ? true : null}
                            >
                                {label}
                            </div>
                        );
                    })}
                </div>
                <div className="gallery-slider__slider">
                    <SliderField
                        onChange={this.handleSliderFieldChange}
                        steps={items.length}
                        initialValue={selectedIndex}
                        customTranslate={value => value}
                    />
                </div>
                <div className="gallery-slider__labels">
                    {bottomLabels.map((label, index) => {
                        return (
                            <div
                                key={index}
                                className="gallery-slider__labels__label"
                                data-selected={selectedIndex === index ? true : null}
                            >
                                {label}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    handleSliderFieldChange(value) {
        const { items, onChange } = this.props;
        const selectedIndex = getSliderItemIndex(value, items);

        // Avoid emitting a change if SliderField hasn't really changed
        if (this.state.selectedIndex !== selectedIndex) {
            this.setState({ selectedIndex });
            onChange(items[selectedIndex]);
        }
    }
}

GallerySlider.propTypes = {
    items: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    variations: PropTypes.array,
    selectedItemIndex: PropTypes.number,
};

GallerySlider.defaultProps = {
    variations: [],
    selectedItemIndex: 0,
};

function getSliderItemIndex(value, items) {
    return parseInt(value, 10) + Math.ceil(items.length / 2) - 1;
}

export default GallerySlider;
